import { makeStyles } from "@material-ui/styles";

const teamButtonStyles = makeStyles((theme) => ({
	image: {
		position: "relative",
		height: 200,
		maxWidth: 240,
		width: "100%",
		[theme.breakpoints.down("xs")]: {
			width: "100% !important", // Overrides inline-style
			height: 100
		},
		border: "1px solid rgba(255,255,255,0.2)",
		borderRadius: 5,
		background:
			"linear-gradient(333.43deg, rgba(0,0,0,0.1) 0%, rgba(255,255,255,0.1) 100%)",
		"&:hover, &$focusVisible": {
			zIndex: 1,
			"& $imageBackdrop": {
				opacity: 0.15
			},
			"& $imageMarked": {
				opacity: 0
			},
			"& $imageTitle": {
				border: "4px solid currentColor"
			}
		}
	},
	focusVisible: {},
	selected: {
		border: "1px solid rgba(255,255,255,1)"
	},
	disabled: {
		opacity: ".5"
	}
}));

export default teamButtonStyles;
